import React, { useEffect } from "react";
import AssetImportSourceAndToken from "../../../AssetImportSourceAndToken";
import CreateGenericImportFlow from "./CreateGenericImportFlow";
import SectionMessage from "@atlaskit/section-message";
import SaveAssetToken from "../../../../common/auth/SaveAssetToken";
import SaveBasicAuth from "../../../../common/auth/SaveBasicAuth";
import { useSelector } from "react-redux";

const ConfirmGenericImport = () => {
  const currentData = useSelector((state) => state.wizard.currentData);

  useEffect(() => {
   
  }, [currentData]);

  return (
    <> 
    <br></br>
     <SectionMessage title="Information" appearance="success">
        <p>
        Great news! Your scheduled API import into Jira Assets is complete and ready to go. Just click the link below to access it.
        </p>
        <AssetImportSourceAndToken />
        <SaveBasicAuth patTokenName="User Import: PAT Token"/>
        <SaveAssetToken assetTokenName="API Import: Asset Import Token"/>
        <CreateGenericImportFlow />
      </SectionMessage>
    
   </>
  );
};
export default ConfirmGenericImport;
